import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-500 text-white hover:bg-brand-600 hover:shadow-lg hover:shadow-brand-500/25 focus:ring-brand-500',
    outline: 'border-2 border-gray-300 bg-transparent text-gray-700 hover:border-brand-500 hover:text-brand-600 focus:ring-brand-500 dark:text-white dark:border-gray-500 dark:hover:border-brand-400 dark:hover:text-brand-400',
    ghost: 'bg-transparent text-gray-600 hover:text-brand-600 hover:bg-brand-50 focus:ring-brand-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-214">
      {children}
    </button>;
}